import React from "react";
import PropTypes from "prop-types";

import css from './FeatureArticleTag.module.scss';

import featureArticleTag from 'assets/feature-article-logo.svg';

const Featurearticletag = () => {
    console.log("featuerarticletag")
    return (
        <div className={css.featureArticleTag}>
            <img src={featureArticleTag} alt="AF-posten artikkel"></img>
        </div>
    );
};

Featurearticletag.propTypes = {
  
};

export default Featurearticletag;



// WEBPACK FOOTER //
// ./src/components/FeatureArticleTag/FeatureArticleTag.jsx